import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-primary text-white" data-id="element-75">
      <div className="max-w-4xl mx-auto" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-77">
          <div className="flex-shrink-0" data-id="element-78">
            <div className="w-24 h-24 rounded-full bg-white/10 flex items-center justify-center border-2 border-accent/50" data-id="element-79">
              <ShieldCheckIcon className="w-12 h-12 text-accent" data-id="element-80" />
            </div>
          </div>

          <div data-id="element-81">
            <h2 className="text-3xl font-bold mb-4 font-serif" data-id="element-82">
              Probalo durante 7 días sin riesgo
            </h2>
            <p className="text-lg text-white/80 leading-relaxed" data-id="element-83">
              Si dentro de los primeros 7 días sentís que este ebook no es para
              vos, podés solicitar la devolución de tu dinero. Quiero que
              compres con total tranquilidad y confianza.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}